"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryEventVariantsJSONModel = void 0;
const AbstractItemsJSONModel_1 = require("src/hello_assets/src/components/model/common/abstractItems/AbstractItemsJSONModel");
const lodash_1 = __importDefault(require("lodash"));
const QueryEventVariantJSONModel_1 = require("src/hello_assets/src/components/model/common/queryEventVariant/QueryEventVariantJSONModel");
class QueryEventVariantsJSONModel extends AbstractItemsJSONModel_1.AbstractItemsJSONModel {
    constructor(serializedState) {
        super(serializedState, {
            serialize: serialize,
            deserialize: deserialize
        });
        this.getQueryEventVariantJSONModel = (uniqueId) => {
            const dataDeserialized = this.getData(uniqueId);
            if (dataDeserialized) {
                return dataDeserialized.queryEventVariantJSONModel;
            }
            return undefined;
        };
        this.addQueryEventVariantJSONModel = (queryEventVariantJSONModel) => {
            return this.addItem(serialize({ queryEventVariantJSONModel: queryEventVariantJSONModel }), false);
        };
        this.hasFilledEvents = () => {
            return lodash_1.default.some(this.getItemsArray(), (item) => {
                return item.data.queryEventVariantJSONModel.isFilled();
            });
        };
        this.getFilledEventNamesSet = () => {
            return lodash_1.default.uniq(this.getFilledEventNames());
        };
        this.getNumberOfQueryEventVariants = () => {
            return lodash_1.default.size(this.getQueryEventVariantArray());
        };
        this.getQueryEventVariantArray = () => {
            return lodash_1.default.compact(this.mapItems((uniqueId, itemIndex, dataDeserialized) => {
                const queryEventVariantJSONModel = dataDeserialized.queryEventVariantJSONModel;
                if (queryEventVariantJSONModel.isFilled()) {
                    return queryEventVariantJSONModel.getValueAsQueryEventVariant();
                }
                return undefined;
            }));
        };
        this.removeNotFilledQueryEventVariants = () => {
            const uniqueIdsToRemove = lodash_1.default.reject(this.mapItems((uniqueId, itemIndex, dataDeserialized) => {
                if (!dataDeserialized.queryEventVariantJSONModel.isFilled()) {
                    return uniqueId;
                }
            }), lodash_1.default.isUndefined);
            lodash_1.default.each(uniqueIdsToRemove, uniqueId => this.removeItem(uniqueId));
        };
        ////////////////////////////////////////////////
        // Private
        ////////////////////////////////////////////////
        this.getFilledEventNames = () => {
            return lodash_1.default.compact(lodash_1.default.map(this.getItemsSortedArray(), function (item) {
                const queryEventVariantJSONModel = item.data.queryEventVariantJSONModel;
                const value = queryEventVariantJSONModel.getValue();
                if ((value === null || value === void 0 ? void 0 : value.type) === "event" && value.event.isFilled()) {
                    return value.event.getName();
                }
                return undefined;
            }));
        };
    }
}
exports.QueryEventVariantsJSONModel = QueryEventVariantsJSONModel;
const serialize = (deserializedValue) => {
    return deserializedValue.queryEventVariantJSONModel.serialize();
};
const deserialize = (serializedValue) => {
    const queryEventVariantJSONModelSerializedState = serializedValue;
    const queryEventVariantJSONModel = new QueryEventVariantJSONModel_1.QueryEventVariantJSONModel(queryEventVariantJSONModelSerializedState);
    return {
        queryEventVariantJSONModel: queryEventVariantJSONModel
    };
};
